import LoadingImg from "../../Media/loading.gif";
const Loading = ()=>{
    return (
        <div className="common-bg">
            <div className="lodding">
                <div className="lodding-text">
                    <div className="logo">
                        <div className="logo-stone">
                            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 15" width="50" height="28" fill="#cae9f9">
                                <g id="Layer_1-2">
                                    <g>
                                        <path className="s0" d="m12.09 0.18c4.77-0.72 14.09 0.58 14.2 6.78 0.1 6.12-10.93 7.89-15.55 7.92-15.53 0.11-11.57-12.75 1.35-14.7z"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div className="logo-stone">
                            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 24" width="70" height="34" fill="#a7d9f8">
                                <g id="Layer_1-2">
                                    <g>
                                        <path className="s0" d="m24.02 0.41c7.28-0.75 28.98 1.03 23.48 12.81-1.94 4.16-14.07 10.89-18.23 10.7-3.71-0.17-21.29-4.12-24.7-5.59-2.32-1-5.4-4.09-4.3-6.65 2.32-5.46 18.08-10.68 23.75-11.26z"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        
                        
                        <div className="logo-stone">
                            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 36" width="80" height="47" fill="#66afd3">
                                <g id="Layer_1-2">
                                    <g>
                                        <path className="s0" d="m34.99 0.28c4-0.34 7.01-0.06 10.79 1.32 10.71 3.9 22.85 22.76 8.45 29.78-3.27 1.6-15.18 4.24-18.75 4.24-4.87 0-24.48-3.58-28.63-5.76-7.32-3.84-9.52-14.15-2.84-19.66 4.94-4.07 24.34-9.36 30.98-9.92z"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Loading;